import { render, staticRenderFns } from "./selectproject.vue?vue&type=template&id=16dcfe44&scoped=true"
import script from "./selectproject.vue?vue&type=script&lang=js"
export * from "./selectproject.vue?vue&type=script&lang=js"
import style0 from "./selectproject.vue?vue&type=style&index=0&id=16dcfe44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dcfe44",
  null
  
)

export default component.exports